module.exports = __webpack_public_path__ + "img/02.56d2fe52.jpg";